export default "__VITE_ASSET__ibpSQUm0__"